import { Module } from "@/constants";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect, { Option, type AsyncSelectBaseProps } from "./AsyncSelect";
import { fetchInvoicingCompanyList } from "@/services/invoicingCompany";
import appConfiguration from "./cfg/AppCfg";

interface InvoicingCompanySelectProps extends AsyncSelectBaseProps {
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, InvoicingCompanySelectProps>(
  function InvoicingCompanySelect({ defaultItem, ...props }, ref) {
    const { t } = useTranslation();

    return (
      <AsyncSelect
        queryKey={[Module.InvoicingCompanies]}
        queryFn={() =>
          fetchInvoicingCompanyList({
            limit: appConfiguration.selectComponentsPaginationLimit,
          })
        }
        enableFilter={false}
        placeholder={t("invoicingCompanySelect.placeholder")}
        loadingLabel={t("invoicingCompanySelect.loadingProjectTypes")}
        {...props}
        defaultItem={defaultItem}
        ref={ref}
        className="w-full"
      />
    );
  },
);
